<template>
  <div>.</div>
</template>

<script>
  export default {
    mounted() {
      var $this = this
      var code = this.$route.query.code;
      localStorage.setItem('code',code)
      localStorage.setItem('v21406','yes')
      // console.log(code)
      if (!code) {
        this.$router.replace('/')
      } else {
        var param={code: code}
        var qs = require('qs');
        let url = this.api.userApi.getUserInfo
        this.axios.post(url,qs.stringify(param),)
        .then((res) => {
          // console.log(res)
          if(res.code==0){
            // var expires = new Date(new Date(new Date().getTime() + 24 * 60 * 60 * 1000 * 7).setHours(0, 0, 0, 0));

            // console.log((new Date(new Date(new Date().getTime() + 24 * 60 * 60 * 1000 * 7).setHours(0, 0, 0, 0))).getTime())
            // console.log(new Date().getTime())
            // var timeStemp=(new Date(new Date(new Date().getTime() + 24 * 60 * 60 * 1000 * 14).setHours(0, 0, 0, 0))).getTime()
            // // var timeStemp=(new Date(new Date(new Date().getTime() + 60 * 1000 * 3))).getTime()
            // console.log('timeStemp:'+timeStemp)
            // console.log('newDate:'+new Date())
            // localStorage.setItem('identity_info',timeStemp)



            localStorage.setItem("openid", res.data.openid);
            if(res.data.token==''||res.data.token==undefined||res.data.token==null){
              console.log('new user')
            }else{
              localStorage.setItem("token", res.data.token);

            }
            console.log('当前获取缓存的路由'+localStorage.getItem("routerCur"))
            if (localStorage.getItem("routerCur")==null||localStorage.getItem("routerCur")==undefined||localStorage.getItem("routerCur")=='') {
            console.log('执行路由1'+localStorage.getItem("routerCur"))
              $this.$router.push({
                path: "/",
              })
            } else {
              if(localStorage.getItem("routerCur")=='/welcome'){
              console.log('执行路由2'+localStorage.getItem("routerCur"))
                $this.$router.push({
                  path: '/welcome?__source='+localStorage.getItem('source'),
                })
              }else{
              console.log('执行路由3'+localStorage.getItem("routerCur"))
                $this.$router.push({
                  path: localStorage.getItem("routerCur"),
                })
              }
            }
          }else{
          console.log('执行路由4'+localStorage.getItem("routerCur"))
            $this.$toast(res.msg);
            $this.$router.push({
              name:'index'
            })
          }
        }).catch((error) => {
        console.log('执行路由5'+localStorage.getItem("routerCur"))
          console.warn(error)
          $this.$toast(res.msg);
          $this.$router.push({
            name:'index'
          })
        })
      }
    },
    methods: { }


  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/author.vue